// Reads the public /api/config endpoint once on mount to learn whether this
// deployment is the demo sandbox. Unauthenticated by design — the endpoint is
// mounted before the Clerk gate — so the DEMO banner can render on any page,
// including before a tenant session resolves.
import { useEffect, useState } from 'react';

let cached: boolean | null = null;

export function useDemoMode(): boolean {
  const [demoMode, setDemoMode] = useState<boolean>(cached ?? false);

  useEffect(() => {
    if (cached !== null) return;
    let alive = true;
    fetch('/api/config')
      .then((r) => (r.ok ? r.json() : { demoMode: false }))
      .then((d) => {
        cached = Boolean(d?.demoMode);
        if (alive) setDemoMode(cached);
      })
      .catch(() => { /* default to non-demo on error */ });
    return () => { alive = false; };
  }, []);

  return demoMode;
}
